(function () {
  'use strict';
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var ROOT = (window.PF && window.PF.root) || '/';
  var FREE = (window.PF && window.PF.free) || 7000;
  var money = function (c) { return (c / 100).toLocaleString('fr-BE', { style: 'currency', currency: 'EUR' }); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var url = function (p) { return ROOT.replace(/\/$/, '') + '/' + p.replace(/^\//, ''); };

  /* ---------- overlays ---------- */
  var scrim = $('#scrim');
  function closeAll() {
    ['#drawer', '#mnav', '#search'].forEach(function (s) { var el = $(s); if (el) { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); } });
    if (scrim) scrim.classList.remove('open');
  }
  function open(sel, withScrim) {
    closeAll(); var el = $(sel); if (!el) return;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    if (withScrim && scrim) scrim.classList.add('open');
  }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  var bind = function (sel, fn) { var el = $(sel); if (el) el.addEventListener('click', fn); };
  bind('#openMenu', function () { open('#mnav'); });
  bind('#closeMenu', closeAll);
  bind('#closeCart', closeAll);
  bind('#openSearch', function () { open('#search', true); setTimeout(function () { var q = $('#q'); if (q) q.focus(); }, 150); });
  bind('#closeSearch', closeAll);
  bind('#openCart', function (e) { if (document.body.classList.contains('tpl-cart')) return; e.preventDefault(); openCart(); });

  var tt;
  function toast(m) { var t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('show'); }, 2400); }

  /* ---------- panier ---------- */
  function setCount(n) { var b = $('#cartCount'); if (!b) return; b.textContent = n; b.hidden = n === 0; }
  function meter(total) {
    var left = Math.max(0, FREE - total), pct = Math.min(100, total / FREE * 100);
    return '<div class="ship-meter"><span>' + (left > 0 ? 'Plus que <b>' + money(left) + '</b> pour la livraison offerte' : '<b>Livraison offerte</b> sur cette commande') + '</span><div class="meter"><i style="width:' + pct + '%"></i></div></div>';
  }
  function renderDrawer(cart) {
    setCount(cart.item_count);
    var body = $('#drawerBody'), ft = $('#drawerFt');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><p>Votre panier est vide pour l’instant.</p><a class="btn btn-primary" href="/collections/tous-les-produits">Voir les produits</a></div>';
      ft.innerHTML = ''; return;
    }
    body.innerHTML = meter(cart.total_price) + cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      return '<div class="line">' + (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
        '<div><h4>' + esc(it.product_title) + '</h4>' + variant +
        '<div class="mini-qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button><output>' + it.quantity + '</output><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div></div>' +
        '<div class="price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    ft.innerHTML = '<div class="totals"><div><span>Sous-total</span><span>' + money(cart.total_price) + '</span></div><div><span>Livraison</span><span>' + (cart.total_price >= FREE ? 'Offerte' : 'Calculée au paiement') + '</span></div></div>' +
      '<a class="btn btn-sun btn-block" href="/checkout">Passer commande</a><a class="link" style="text-align:center" href="/cart">Voir le panier</a>';
  }
  function fetchCart() { return fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openCart() { open('#drawer', true); fetchCart().then(renderDrawer); }
  function addItems(items, name, openAfter) {
    return fetch(url('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Ajout impossible'); return j; }); })
      .then(function () { toast((name || 'Produit') + ' ajouté au panier'); return fetchCart(); })
      .then(function (cart) { renderDrawer(cart); if (openAfter !== false) open('#drawer', true); return cart; })
      .catch(function (e) { toast(e.message); throw e; });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('#drawer [data-line]');
    if (q) {
      $('#drawer').classList.add('drawer-loading');
      fetch(url('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: Math.max(0, +q.dataset.q) }) })
        .then(function (r) { return r.json(); }).then(renderDrawer)
        .finally(function () { $('#drawer').classList.remove('drawer-loading'); });
      return;
    }
    var a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); addItems([{ id: +a.dataset.add, quantity: 1 }], a.dataset.name); }
  });

  /* ---------- recherche prédictive ---------- */
  var qi = $('#q'), res = $('#results'), timer;
  if (qi && res) {
    qi.addEventListener('input', function () {
      clearTimeout(timer);
      var t = qi.value.trim();
      if (!t) { res.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(url('search/suggest.json') + '?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            res.innerHTML = ps.length ? ps.map(function (p) {
              return '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="">' : '') + '<span><b>' + esc(p.title) + '</b><br><small class="price">' + money(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
            }).join('') : '<p style="color:var(--muted)">Aucun produit pour « ' + esc(t) + ' ». Essayez « brosse », « griffes » ou « canapé ».</p>';
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------- tri des collections ---------- */
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* ---------- copie e-mail ---------- */
  bind('#copyMail', function () {
    var done = function () { toast('Adresse copiée'); };
    var fallback = function () { var r = document.createRange(); r.selectNodeContents($('#mail')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); toast('Adresse sélectionnée'); };
    if (navigator.clipboard) navigator.clipboard.writeText('contact@pawfam.net').then(done, fallback); else fallback();
  });

  /* ---------- fiche produit ---------- */
  var pdp = $('#pdp');
  if (pdp) {
    var data = JSON.parse($('#pdpData').textContent);
    var state = { id: data.current, q: 1 };
    var name = pdp.dataset.name;
    var main = $('#mainImg');
    var variant = function () { return data.variants.filter(function (v) { return v.id === state.id; })[0] || data.variants[0]; };

    function showThumb(btn) {
      $$('#thumbs button').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      if (btn.dataset.video) {
        main.innerHTML = '<video src="' + btn.dataset.video + '" poster="' + btn.dataset.poster + '" autoplay muted loop playsinline style="object-fit:contain;background:#111"></video>';
      } else {
        main.innerHTML = '<img src="' + btn.dataset.src + '" alt="' + btn.dataset.alt + '">';
      }
    }
    var thumbs = $('#thumbs');
    if (thumbs) thumbs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) showThumb(b); });

    function update() {
      var v = variant();
      var vn = $('#vName'); if (vn) vn.textContent = v.title;
      $$('#variants button').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.v === v.id ? 'true' : 'false'); });
      $('#price').textContent = money(v.price);
      $('#qv').textContent = state.q;
      $('#stock').innerHTML = '<span class="stock">' + (v.available ? 'En stock' : 'Momentanément épuisé') + '</span>';
      $('#addBtn').disabled = !v.available; $('#buyNow').disabled = !v.available;
      var sb = $('#stickyBuy');
      sb.innerHTML = '<div style="min-width:0;flex:1"><b style="display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(name) + '</b><small class="price">' + money(v.price) + (data.variants.length > 1 ? ' · ' + esc(v.title) : '') + '</small></div><button type="button" class="btn btn-primary" id="stickyAdd"' + (v.available ? '' : ' disabled') + '>Ajouter</button>';
      $('#stickyAdd').onclick = function () { addItems([{ id: v.id, quantity: state.q }], name); };
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    var vs = $('#variants');
    if (vs) vs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v]'); if (!b) return;
      state.id = +b.dataset.v;
      var v = variant();
      if (v.media) { var t = $('#thumbs [data-media="' + v.media + '"]'); if (t) showThumb(t); }
      update();
    });
    bind('#qm', function () { state.q = Math.max(1, state.q - 1); update(); });
    bind('#qp', function () { state.q = Math.min(10, state.q + 1); update(); });
    bind('#addBtn', function () { addItems([{ id: state.id, quantity: state.q }], name); });
    bind('#buyNow', function () { addItems([{ id: state.id, quantity: state.q }], name, false).then(function () { location.href = '/checkout'; }); });
    bind('#addPair', function () {
      var items = [{ id: state.id, quantity: 1 }];
      if (pdp.dataset.pair) items.push({ id: +pdp.dataset.pair, quantity: 1 });
      addItems(items, name + ' et ' + pdp.dataset.pairName.toLowerCase());
    });
    update();

    var sb = $('#stickyBuy'), target = $('#addBtn');
    if ('IntersectionObserver' in window && sb && target) {
      new IntersectionObserver(function (en) {
        sb.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(target);
    }
  }
})();
